<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <TextFilter :label-text="$t('common.company')"
                        columnName="companyName"
                        ref="filter_companyName"
            ></TextFilter>
			<CountryFilter :label-text="$t('common.country')"
						   column-name="country"
						   :company-type="enumDef.companyType.DebtorCompany"
						   ref="filter_country">
			</CountryFilter>
            <TextFilter :label-text="$t('common.vatId')"
                        columnName="vatNumber"
                        ref="filter_vatNumber"
            ></TextFilter>
            <TextFilter :label-text="$t('common.street')"
                        columnName="street"
                        ref="filter_street"
            ></TextFilter>
            <TextFilter :label-text="$t('common.postcode')"
                        columnName="postCode"
                        ref="filter_postCode"
            ></TextFilter>
            <TextFilter :label-text="$t('common.city')"
                        columnName="city"
                        ref="filter_city"
            ></TextFilter>
		</div>
		<div class="filter_item">
            <FromToFilter :label-text="config.nameRating1OrDefault"
                          columnName="rating1"
                          ref="filter_rating1"
            ></FromToFilter>
            <FromToFilter :label-text="config.nameRating2OrDefault"
                          columnName="rating2"
                          ref="filter_rating2"
            ></FromToFilter>
            <FromToFilter :label-text="config.nameRating3OrDefault"
                          columnName="rating3"
                          ref="filter_rating3"
            ></FromToFilter>
            <DateFilter :label-text="$t('common.updateDate')"
                        columnName="lastUpdateTime"
                        ref="filter_lastUpdateTime"
            ></DateFilter>
			<DateFilter :label-text="$t('common.lastPurchase')"
						columnName="lastPurchaseTime"
						ref="filter_lastPurchaseTime"
			></DateFilter>
        </div>
    </TableFilter>
</template>

<script>
import TextFilter from "@/components/newFilter/TextFilter.vue";
import FromToFilter from "@/components/newFilter/FromToFilter.vue";
import DateFilter from "@/components/newFilter/DateFilter.vue";
import TableFilter from "@/components/newFilter/TableFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter.vue";
import {enumDef} from "@/common/enumDefs";

export default {
    components: { CountryFilter, TableFilter, TextFilter, FromToFilter, DateFilter},
	props: {
		config: { type: Object, default: null }
	},
    data() {
        return {
			enumDef: enumDef
		};
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    }
};
</script>